@switch (element.modelType) {
  @case (SubmodelElementTypes.SubmodelElementCollection) {
    <ix-blind
      [label]="element.idShort | translateOrFallback: element.idShort ?? ''"
      [collapsed]="false"
    >
      <ix-key-value-list>
        @for (child of children; track child.idShort) {
          <app-dpp-submodel-field [element]="child" />
        }
      </ix-key-value-list>
    </ix-blind>
  }

  @case (SubmodelElementTypes.SubmodelElementList) {
    <app-key-value
      icon="list"
      [label]="element.idShort | translateOrFallback: element.idShort ?? ''"
      class="nested-list-group align-items-start"
    >
      @for (item of listItems; track $index) {
        <div slot="custom-value" class="nested-field-group mb-3">
          @if (
            item.modelType === SubmodelElementTypes.SubmodelElementCollection
          ) {
            <ix-blind
              [label]="
                (element.idShort | translateOrFallback: element.idShort ?? '') +
                ' [' +
                $index +
                ']'
              "
              [collapsed]="false"
            >
              <ix-key-value-list>
                @for (child of listItemChildren(item); track child.idShort) {
                  <app-dpp-submodel-field [element]="child" />
                }
              </ix-key-value-list>
            </ix-blind>
          } @else {
            <app-dpp-submodel-field [element]="item" />
          }
        </div>
      }
    </app-key-value>
  }

  @default {
    <app-key-value
      [icon]="icon"
      [label]="element.idShort | translateOrFallback: element.idShort ?? ''"
      [value]="leafValue"
    >
    </app-key-value>
  }
}
